import { render } from "./PriceToggle.vue?vue&type=template&id=1e6c063b"
import script from "./PriceToggle.vue?vue&type=script&lang=js"
export * from "./PriceToggle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__